// Imports
import { useStateValue } from '../../_global/jsx/store';
import { ReactQuestionSlider } from '../../ReactQuestionSlider/jsx/component.jsx';

import { dangerousHTML } from 'src/lib/utils.js';
// Binds

// Stateful components

export const ReactDetailedQuestionSection = () => {

    const [{ globalText, userData, controlData }, dispatch] = useStateValue();

    
    const getAllDetailQuestions = () => {
        let questions = controlData.currentItem.children;

        if (typeof(questions) !== 'undefined') {

            //filter out the questions that are linked to rapid assessment questions in which the user has selected Yes(0);
            var filteredQuestions = questions.filter((question) =>{
                if (question.qType === 'rangeSlider') {
                    //check if the this question has a linked rapid assessment question
                    //linkedRapidQuestion
                    if(typeof(question.linkedRapidQuestion) !== "undefined"){
                        if(question.linkedRapidQuestion !== ""){
                            var userResponse = userData.questionResponses[question.linkedRapidQuestion]; 
                            //if the user has answered yes(0) - then do not show this question
                            if(userResponse === 0){
                                return false;
                            }
                        }
                    }
                    return true;
                }
                return false;
            });            


            var allQuestions = filteredQuestions.map((question, idx1) => {              

                return <ReactQuestionSlider key={"question__" + idx1} question={question} />
                
            });

            //if all questions have been filtered out due to users answering all Yes(0) for the linked section in the rapid assessment
            
            if(filteredQuestions.length == 0){
                return <> <div dangerouslySetInnerHTML={dangerousHTML(globalText.detailedAssessmentRapid100)}></div></>;
                
            }else{
                return allQuestions;
            }
            
        }

        return null;
    }

    return (
        <div>

            {getAllDetailQuestions()}
            <hr/>

        </div>
    );
};
